<form #airportForm="ngForm">
    <div class="row">
        <div class="col-sm-4">
            <select [ngModel]="airports.airport" (ngModelChange)="airportChanged($event);airports.airport=$event" required name="aux.{{index}}.airport" type="text" class="form-control" id="aux-{{index}}-airport">
        <option value="" disabled>---</option>
        <option *ngFor="let pT of selectedAirportTypes" [disabled]="!pT.selectable" value="{{pT.code}}">{{pT.name}}</option>
      </select>
        </div>

        <div class="col-sm-3">
            <div class="input-group">
                <input class="form-control" currencyMask [(ngModel)]="airports.currencyMaskPrice" [options]="{ prefix: '', thousands: '.', decimal: ',', suffix: ' €' }" (ngModelChange)="displayCurrentValue($event)" name="price-one" />
            </div>
            <!-- <div class="input-group">
                <input [(ngModel)]="airports.priceForAdmin" (change)="SetValueOfPrice(airports.priceForAdmin)" #price="ngModel" required name="aux.{{index}}.price" pattern="^(?:([+-]?\d+(\,)\d{2})|(\d+))$" type="text" class="form-control" id="aux-{{index}}-price">
                <span class="input-group-addon">
              &euro;
          </span>
            </div>
            <div *ngIf="price.invalid && (price.dirty || price.touched)" class="alert alert-danger">
                <div *ngIf="price.errors.required">
                    Must have one price
                </div>
                <div *ngIf="price.errors.pattern">
                    Must be in correct format
                </div>
            </div> -->
        </div>
        <div class="col-sm-2">
            &nbsp;
        </div>

        <div class="col-sm-1">
            <input [(ngModel)]="airports.active" name="aux.{{index}}.active" type="checkbox" class="form-control mt-3" id="aux-{{index}}-active">
        </div>

        <div class="col-sm-2 pt-2  text-center">
            <i class="fa fa-clone" style="cursor: pointer;" alt="Kopieren" title="{{'simple-travel-form.hint.copy.entry' | translate}}" (click)="copyAuxiliary(airports, index)"></i>
            <i class="fa fa-trash" style="cursor: pointer;" alt="Löschen" title="{{'simple-travel-form.hint.delete.entry' | translate}}" (click)="deleteAuxiliary(airports, index)"></i>
        </div>
    </div>
    <button hidden="true" (click)="sendForm(airportForm.valid)" id="airport-{{index}}">TEST</button>
</form>


// WEBPACK FOOTER //
// ./src/app/product/simple-travel-form-airports/simple-travel-form-airports.component.html